/* eslint-env node */

import React from 'react';
import PropTypes from 'prop-types';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { ActionBarItem } from 'rio-uikit';

import { EVENT_USER_LOGGED_OUT } from '../constants/api';

import AccountPopoverContainer from '../containers/AccountPopoverContainer';
import UserSettingsDialog from '../containers/SettingsDialogContainer';
import userSettingsReducer from '../reducers/reducer';

import cs from 'react-intl/locale-data/cs';
import da from 'react-intl/locale-data/da';
import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import et from 'react-intl/locale-data/et';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import lt from 'react-intl/locale-data/lt';
import lv from 'react-intl/locale-data/lv';
import nl from 'react-intl/locale-data/nl';
import no from 'react-intl/locale-data/no';
import pl from 'react-intl/locale-data/pl';
import pt from 'react-intl/locale-data/pt';
import ro from 'react-intl/locale-data/ro';
import sk from 'react-intl/locale-data/sk';
import sv from 'react-intl/locale-data/sv';

import { IntlProvider, addLocaleData, FormattedMessage } from 'react-intl';
import { accessTokenStored } from '../actions/settingsActions';
import { selectLanguage } from '../selectors/settingsSelectors';

import { runSagas } from '../sagas/rootSaga';
import { Provider, connect } from 'react-redux';

import style from '../style/css/rio-accountmenu.less';

// Initialize middlewares
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = /*window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__; // || */ compose;
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(sagaMiddleware))(createStore);
const mountedStore = createStoreWithMiddleware(userSettingsReducer);

runSagas(sagaMiddleware);

addLocaleData([
    ...cs,
    ...da,
    ...de,
    ...en,
    ...es,
    ...et,
    ...it,
    ...lt,
    ...lv,
    ...fr,
    ...nl,
    ...no,
    ...pl,
    ...pt,
    ...ro,
    ...sk,
    ...sv,
]);

function mapStateToProps(state) {
    const lang = selectLanguage(state);
    return {
        locale: lang.locale,
        messages: lang.messages,
    };
}

const ConnectedIntlProvider = connect(mapStateToProps)(IntlProvider);

const broadcastLogout = () => {
    document.dispatchEvent(new CustomEvent(EVENT_USER_LOGGED_OUT));
};

// FIXME: use the correct usersettings absolute URL
// TODO: implement React-style callback API for events with onLanguageChanged, onLoggedOut, onProfileChanged

/*

  <div className={`${style.AccountMenuComponent}`}>
  </div>

*/

const DefaultAccountMenu = ({ accessToken, userSettingsEndpoint }) => {
    // FIXME: This is not optimal but will work to get the token into the store
    mountedStore.dispatch(accessTokenStored(accessToken));

    return (
        <Provider store={mountedStore}>
            <ConnectedIntlProvider>
                <ActionBarItem id={'accountMenu'}>
                    <ActionBarItem.Icon>
                        <span className={'icon rioglyph rioglyph-user'}></span>
                        <UserSettingsDialog backendUrl={userSettingsEndpoint}/>
                    </ActionBarItem.Icon>
                    <ActionBarItem.Popover title={<FormattedMessage id={'userSettings.popover.title'} />}>
                    <AccountPopoverContainer backendUrl={userSettingsEndpoint} onLogout={broadcastLogout} />
                    </ActionBarItem.Popover>
                </ActionBarItem>
            </ConnectedIntlProvider>
        </Provider>
    );
};

DefaultAccountMenu.defaultProps = {
    //onLanguageChanged: noop,
    //onLoggedOut: noop,
    //onProfileChanged: noop,
    userSettingsEndpoint: '/usersettings',
};

DefaultAccountMenu.propTypes = {
    accessToken: PropTypes.string.isRequired,
    //onLanguageChanged: PropTypes.func,
    //onLoggedOut: PropTypes.func,
    //onProfileChanged: PropTypes.func,
    userSettingsEndpoint: PropTypes.string,
};

export default DefaultAccountMenu;
